import { makeStyles, theme } from '@focaldata/cin-ui-components'

const useStyles = makeStyles()({
  id: {
    paddingRight: theme.spacing(1.5)
  }
})

export default useStyles
